import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const login = async (data) => {
  const res = await api.post(networkConfig.auth.login, data);
  return res.data;
};

export const forgotPassword = async (email) => {
  const res = await api.post(networkConfig.auth.forgotPassword, email);
  return res.data;
};

export const verifyOtp = async (data) => {
  const res = await api.post(networkConfig.auth.verifyOtp, data);
  return res.data;
};

export const resetPassword = async (data) => {
  const res = await api.patch(networkConfig.auth.resetPassword, data);
  return res.data;
};
